import { cn } from "src/lib/cn";

/** Small tinted chip used for composer controls: chat's mode switcher / mention (#) chrome and the image generator's Styles picker. */
export const composerChromeButtonClassName = cn(
  "rounded-[10px] border-solid shrink-0 h-[28px] min-h-[28px] px-1.5 text-xs font-normal leading-none transition-all flex items-center justify-center gap-1 cursor-pointer",
  "border-app-primary-cta-translucent text-app-primary-cta-high-contrast bg-app-primary-cta-50 border-[1px]",
  "hover:bg-app-primary-cta-100 hover:border-app-primary-cta-200 hover:text-app-primary-cta-high-contrast",
  "focus-visible:bg-app-primary-cta focus-visible:border-app-primary-cta focus-visible:text-app-cta-text-color",
  "disabled:opacity-30",
);
